import React, { useEffect, useState } from "react";
import { getEmployeeId, mapTableRows } from "../../../../../../../utils";
import {
  Button,
  CustomInput,
  FormFieldSet,
  InfoCardNewAdv,
  InfoTimeCardAdv,
  KeyValue,
  Modal,
  NewTable,
  NewTableAdv,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../../../../components";
import {
  BulkInvoicesEmployeeOptions,
  ClientPaymentmethodOpetions,
} from "../../../../../../../assets/data/projectData";
import Unapaidtimesheet from "./Unapaidtimesheet";
import { recviedpaymentmodelrows } from "../../../../../../../assets/data/candidatesData";
import { calcLength } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../../../hooks/useLoginUser";
import common from "../../../../../../../utils/common";
import { empRecieveSelectDeductionsStart } from "../../../../../../../redux/slices/employee/employeeSlice";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../../redux/slices/universal/fileUploadSlice";
import { addDeductionStart } from "../../../../../../../redux/slices/payroll/payrollSlice";
import { formatCurrency } from "../../../../../../../utils/stringUtils";
const ReceivePayments = ({
  onClose,
  isOpen,
  setActiveTab,
  shouldMoveTab = false,
  empDeductions = [],
  type = 2,
  unpaidTime = false,
  selectTimeSheet = [],
  callFunction,
  customerPendingBalance,
  kpiLoadingPendingBal,
}) => {
  console.log("selectTimeSheet", selectTimeSheet);
  const {
    convertToUSD,
    distributePayment,
    generateUpdatePayload,
    updateDeductionsData,
    calculateBalances,
    generateTimeSheetsUpdatePayloads,
    updateTimeSheetData,
  } = common;
  const dispatch = useDispatch();
  const [kpiLoading, setKpiLoading] = useState(false);
  const [ismodel, setismodel] = useState(false);
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    empRecieveSelectDeductions,
  } = useSelector((state) => state.employee);
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;

  const filterActive = empDeductions.filter((data) => data.stop === false);
  const updatedFilterActive = filterActive
    .filter((entry) => entry.deductionType !== 2)
    .map((entry) => {
      const filteredInstallments = entry.installments.filter((inst) => {
        if ("received" in inst) {
          return inst.received !== inst.receivable;
        }
        return true;
      });

      const filteredInstallmentsCompleted = entry.installments.filter(
        (inst) => {
          if ("received" in inst) {
            return inst.received === inst.receivable;
          }
          return false;
        },
      );

      const openBalance = filteredInstallments.reduce((total, inst) => {
        return total + (inst.receivable - (inst.received || 0));
      }, 0);

      return {
        ...entry,
        pendingInstallments: filteredInstallments,
        originalAmount: entry?.amounts?.deducted || 0,
        openBalance,
        payment: 0,
        completedInstallments: filteredInstallmentsCompleted,
        id: entry?.uiid,
      };
    })
    .filter((entry) => entry.openBalance > 0);

  const [showUnpaidtimesheet, setShowUnpaidtimesheet] = useState(false);
  const defaultvalues = {
    employee: "",
    paymentDate: "",
    paymentMethod: "",
    referenceNumber: "",
    depositTo: "",
    attachment: [],
    inrAmount: "",
    exchangeAmount: "",
    amountReceived: "",
    freezeAmount: "",
  };
  const [formRules, setFormRules] = useState({});
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(defaultvalues, formRules);
  useEffect(() => {
    const defaultRules = {
      amountReceived: { type: "text", required: true },
      ...(!unpaidTime && {
        depositTo: { type: "select", required: true },
        exchangeAmount: { type: "text", number: true, required: true },
        inrAmount: { type: "text", number: true, required: true },
      }),
      attachment: { type: "file" },
    };

    setFormRules(defaultRules);
  }, []);
  const isFreeze = formData.freezeAmount?.includes("true");
  console.log("formData", formData);
  // const tabledata = recviedpaymentmodelrows;
  const [tabledata, setTableData] = useState(
    [],
    //   [
    //   {
    //     id: 1,
    //     description: "H1B CASE 2022",
    //     installments: "9/10",
    //     orinalAmount: "10,000",
    //     openBalance: "1000",
    //     payment: "1000",
    //   },
    //   {
    //     id: 2,
    //     description: "H1B CASE 2022",
    //     installments: "9/10",
    //     orinalAmount: "10,000",
    //     openBalance: "1000",
    //     payment: "1000",
    //   },
    //   {
    //     id: 3,
    //     description: "H1B CASE 2022",
    //     installments: "9/10",
    //     orinalAmount: "10,000",
    //     openBalance: "1000",
    //     payment: "1000",
    //   },
    // ]
  );

  const intialduecolumns = [
    {
      key: "name",
      label: "Description",
    },
    {
      key: "data",
      label: "Installments",
      render: (row) => {
        const total = row?.installments?.length || 0;
        const complete = row?.completedInstallments.length || 0;
        return (
          <div>
            {complete}/{total}
          </div>
        );
      },
    },
    {
      key: "amounts",
      label: "Original Amount",
      render: (row) => {
        const originalAmount = row?.installments?.reduce((total, inst) => {
          return total + (inst?.receivable || 0);
        }, 0);

        return <div>{originalAmount}</div>;
      },
    },
    {
      key: "openBalance",
      label: "Open Balance",
    },
    {
      key: "payment",
      label: "Payment",
      render: (row) => (
        <div>
          {console.log("rowin payment", row)}
          <CustomInput
            type="text"
            placeholder=""
            title=""
            size="xs"
            //temporary fix because mapTableRows is returning always with "-" which is not a default value for this fiels
            value={row?.payment === "-" ? "" : row?.payment}
            disabled={formData.freezeAmount?.includes("true")}
            onChange={(e) => handleChangeTable("payment", row, e)}
          />
        </div>
      ),
    },
  ];

  // console.log("setActiveTab", setActiveTab);
  console.log("tabledata", tabledata);
  const mappedRows = mapTableRows(tabledata, intialduecolumns);
  const handleChangeTable = (field, row, value) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [field]: value } : item,
      ),
    );
    const updatedReduxData = empRecieveSelectDeductions.map((data) => {
      if (data.uiid === row.uiid) {
        return {
          ...data,
          payment: value,
        };
      }
      return data;
    });
    if (
      JSON.stringify(updatedReduxData) !==
      JSON.stringify(empRecieveSelectDeductions)
    ) {
      dispatch(empRecieveSelectDeductionsStart(updatedReduxData)); // replace with your actual dispatch action
    }
  };

  const unpaidTimesheet = () => {
    if (shouldMoveTab && typeof setActiveTab === "function") {
      setActiveTab((prev) => prev + 3);
    } else {
      onClose(); // Only close the modal
    }
  };

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const payload = {
        employeeId: employeeProfileUiid,
        addedBy: loginUserUiid,
        type: type,
        method: formData?.paymentMethod?.value ?? formData?.paymentMethod,
        refNum: formData?.referenceNumber,
        depositTo: formData?.depositTo?.value ?? formData?.depositTo,
        freezeAmt: formData?.freezeAmount,
        amounts: {
          inr: formData?.inrAmount,
          exchange: formData?.exchangeAmount,
          received: formData?.amountReceived,
        },
        payDate: formData?.payDate,
        status: 1,
        // deductionIds:[
        //   id:,
        //   payments:
        // ]
      };
      const cleanedData = filterEmptyValues(payload);
      const cleanAttachments =
        Array.isArray(formData.attachment) && formData.attachment.length > 0
          ? formData.attachment
          : [];
      const onSuccessCallback = async () => {
        const paidAmount = empRecieveSelectDeductions.reduce(
          (total, item) => total + Number(item.payment || 0),
          0,
        );
        const updateData = distributePayment(empRecieveSelectDeductions) || [];
        const payloadData = generateUpdatePayload(updateData) || [];
        console.log(
          "object :::: ",
          empRecieveSelectDeductions,
          updateData,
          payloadData,
        );
        const updatedLastPayload =
          payloadData?.map((item, index) => {
            const isLastInstallment = index === payloadData.length - 1;
            if (!isLastInstallment) {
              return item;
            }
            const updatedPayload = item?.payload || [];
            updatedPayload.push({
              type: "INC",
              value: { "amounts.received": paidAmount },
            });
            return { ...item, payload: updatedPayload };
          }) || [];

        for (const payloadItem of updatedLastPayload) {
          try {
            console.log("payloadItem", payloadItem);
            await updateDeductionsData(payloadItem);
          } catch (error) {
            console.error("Error updating deduction:", error);
          }
        }
        if (unpaidTime) {
          const updatedData = selectTimeSheet.map((entry) => {
            const amounts = entry.amounts || {};
            const total = amounts.total || 0;
            const paid = amounts.paid || 0;
            return {
              ...entry,
              totalTimeAmount: total - paid,
            };
          });
          console.log("updatedData", updatedData, "paidAmount", paidAmount);
          const calculateBalancesData = await calculateBalances(
            updatedData,
            // paidAmount +
            //   updatedData?.reduce(
            //     (total, item) => total + Number(item?.totalTimeAmount || 0),
            //     0
            //   )
            paidAmount,
          );
          console.log("calculateBalancesData", calculateBalancesData);
          const generateTimeSheetsUpdatePayloadsData =
            await generateTimeSheetsUpdatePayloads(calculateBalancesData);
          console.log(
            "generateTimeSheetsUpdatePayloadsData",
            generateTimeSheetsUpdatePayloadsData,
          );
          for (const data of generateTimeSheetsUpdatePayloadsData) {
            console.log("data in loop", data);
            try {
              await updateTimeSheetData(data);
            } catch (error) {
              console.error("Error updating timesheet:", error);
            }
          }
        }
        if (callFunction) {
          callFunction();
        }
        onClose();
        setFormData(defaultvalues);
      };

      if (cleanAttachments.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: employeeProfileUiid,
            entity: "empdeductions",
            category: "empdeductions",
            coll: "EmpDeduction",
            doc: cleanAttachments,
            onSuccess: (fileData) => {
              const attachmentKeys = fileData
                .filter((data) => data.key)
                .map((data) => data.key);
              const updatedSubmissionData = {
                ...cleanedData,
                attachments: attachmentKeys,
              };
              dispatch(
                addDeductionStart({
                  coll: "EmpDeduction",
                  payload: updatedSubmissionData,
                  onSuccess: onSuccessCallback,
                }),
              );
            },
          }),
        );
      } else {
        dispatch(
          addDeductionStart({
            coll: "EmpDeduction",
            payload: cleanedData,
            onSuccess: onSuccessCallback,
          }),
        );
      }
    } else {
      showToast("Please fill all the required fields before saving", "error");
    }
  };
  useEffect(() => {
    let employeeName =
      (employeeDetails?.firstName || "") +
      " " +
      (employeeDetails?.lastName || "") +
      " (" +
      getEmployeeId(employeeDetails?.uiid, employeeDetails?.employmentType) +
      ")";
    handleChange("employee", employeeName || "-");
  }, [employeeDetails?.firstName, isOpen]);

  useEffect(() => {
    const shouldSetTable =
      Array.isArray(tabledata) &&
      tabledata.length === 0 &&
      updatedFilterActive.length > 0;
    if (shouldSetTable) {
      setTableData(updatedFilterActive);
    }
  }, [updatedFilterActive]);

  useEffect(() => {
    setKpiLoading(true);
    const inrAmount = parseFloat(formData?.inrAmount) || 0;
    const exchangeRate = parseFloat(formData?.exchangeAmount) || 0;

    if (inrAmount > 0 && exchangeRate > 0) {
      const usdAmount = inrAmount / exchangeRate;
      handleChange("amountReceived", usdAmount.toFixed(2));
    }

    if (unpaidTime && selectTimeSheet.length > 0) {
      const totalAmount = selectTimeSheet.reduce((total, acc) => {
        const amounts = acc.amounts || {};
        const totalVal = amounts.total || 0;
        const paidVal = amounts.paid || 0;
        return total + (totalVal - paidVal);
      }, 0);
      handleChange("amountReceived", totalAmount.toFixed(2));
    }

    setKpiLoading(false);
  }, [
    formData?.inrAmount,
    formData?.exchangeAmount,
    // selectTimeSheet,
    // unpaidTime,
  ]);
  const handleSelectDeductions = (rows) => {
    let recvAmt = formData.amountReceived || 0;
    tabledata.forEach((data) => {
      if (rows.includes(data.uiid)) {
        data.payment = data.openBalance < recvAmt ? data.openBalance : recvAmt;
        handleChangeTable(
          "payment",
          data,
          data.openBalance < recvAmt ? data.openBalance : recvAmt,
        );
        recvAmt = (
          recvAmt - (data.openBalance < recvAmt ? data.openBalance : recvAmt)
        ).toFixed(2);
      } else {
        data.payment = 0;
        handleChangeTable("payment", data, 0);
      }
    });
    dispatch(empRecieveSelectDeductionsStart(tabledata));
  };

  const handleResetNClose = () => {
    setFormData(defaultvalues);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleResetNClose}
      title="RECIEVE PAYMENT"
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-3 ">
          <div className="col-span-1">
            <FormFieldSet
              type="text"
              title="Employee"
              placeholder="Select Employee"
              value={formData.employee}
              onChange={(value) => handleChange("employee", value)}
              error={errors.employee}
              disabled
              // showButton
              // options={BulkInvoicesEmployeeOptions}
              // showSearch
            />
          </div>

          {/* <div></div> */}

          <div className="lg:col-span-2 flex flex-wrap gap-3 justify-end items-start mt-4 lg:mt-0">
            <div className="w-[200px] h-48">
              <InfoCardNewAdv
                title={"Amount Received"}
                value={formatCurrency(Number(formData.amountReceived))}
                layout="option13"
                isLoading={kpiLoading}
              />
            </div>
            <div className="w-[200px] h-48">
              <InfoCardNewAdv
                title={"Pending Balance"}
                value={formatCurrency(Number(customerPendingBalance))}
                layout="option13"
                isLoading={kpiLoadingPendingBal}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-6 max-w-5xl mt-4">
          <FormFieldSet
            type="datepicker"
            title="Payment Date"
            placeholder="MM/DD/YYYY"
            value={formData.paymentDate}
            onChange={(value) => handleChange("paymentDate", value)}
            error={errors.paymentDate}
            showDropdown={false}
          />
          {!unpaidTime && (
            <div className="mt-4">
              <Button
                title="Show Unpaid Timesheets"
                type="button"
                // onClick={() => setShowUnpaidtimesheet(true)}
                onClick={() => unpaidTimesheet()}
              />
            </div>
          )}
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-6 max-w-5xl mt-4">
          {!unpaidTime && (
            <>
              <FormFieldSet
                type="paymentMethods"
                title="Payment Method"
                placeholder=" select Payment Method"
                value={formData.paymentMethod}
                onChange={(value) => handleChange("paymentMethod", value)}
                error={errors.paymentMethod}
                showButton
                showSearch
                options={ClientPaymentmethodOpetions}
              />
              <FormFieldSet
                type="text"
                title="Reference Number"
                placeholder=" Enter Reference Number"
                value={formData.referenceNumber}
                onChange={(value) => handleChange("referenceNumber", value)}
                error={errors.referenceNumber}
              />
              <FormFieldSet
                type="depositTo"
                title="Deposit To"
                placeholder=" select Deposit To"
                value={formData.depositTo}
                onChange={(value) => handleChange("depositTo", value)}
                error={errors.depositTo}
                showButton
                showSearch
              />
              <FormFieldSet
                type="file"
                title={"Attachment"}
                placeholder="Choose File"
                value={formData.attachment}
                onChange={(value) => handleChange("attachment", value)}
                error={errors.attachment}
              />
              <FormFieldSet
                type="text"
                title="INR Amount"
                placeholder=" Enter INR Amount"
                value={formData.inrAmount}
                onChange={(value) => handleChange("inrAmount", value)}
                error={errors.inrAmount}
              />
              <FormFieldSet
                type="text"
                title="Exchange Amount"
                placeholder=" Enter Exchange Amount"
                value={formData.exchangeAmount}
                onChange={(value) => handleChange("exchangeAmount", value)}
                error={errors.exchangeAmount}
              />
            </>
          )}
          <FormFieldSet
            type="text"
            title="Amount Received"
            placeholder="Enter Amount Received"
            value={formData.amountReceived}
            onChange={(value) => handleChange("amountReceived", value)}
            error={errors.amountReceived}
            disabled={true}
          />
          {!unpaidTime && (
            <FormFieldSet
              type="checkbox"
              size="md"
              title=" "
              options={[
                {
                  label: "Freeze Amount",
                  value: "true",
                },
              ]}
              values={formData.freezeAmount || []}
              onChange={(value) => handleChange("freezeAmount", value)}
            />
          )}
        </div>
        <h5 className="my-6">OutStanding Transactions</h5>
        <div className={`mt-5 ${isFreeze ? "cursor-not-allowed" : ""}`}>
          <NewTableAdv
            columns={intialduecolumns}
            rows={mappedRows}
            // hideToolBar
            //  toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
            serverPagination={false}
            showCheckbox
            onSelectionChange={(change) => {
              handleSelectDeductions(change);
            }}
            disableSelection={formData?.freezeAmount == "true"}
          />
        </div>
        <div className="flex mt-4 justify-end w-full">
          {/* <div className="flex-1"></div>
          <div className="flex-1"></div> */}
          <div className="bg-primary-50 rounded-sm py-2 flex flex-col p-8 w-[50%] justify-end">
            <div className="flex">
              <div className="flex-1 items-end">
                <PageTitle title={"Received Amount"} tag="span" />
              </div>
              <div className="flex">
                <PageTitle
                  title={formatCurrency(Number(formData.amountReceived))}
                  tag="span"
                />
              </div>
            </div>
            <div className=" flex ">
              <div className="flex-1  items-end">
                <PageTitle title={"Selected Amount"} tag="span" />
              </div>
              <div className="flex">
                <PageTitle
                  title={formatCurrency(
                    empRecieveSelectDeductions.reduce(
                      (total, item) => total + Number(item?.payment || 0),
                      0,
                    ),
                  )}
                  tag="span"
                />
              </div>
            </div>
            <div className=" flex ">
              <div className="flex-1 items-end">
                <PageTitle title={"Difference Amount"} tag="span" />
              </div>
              <div className="flex">
                <PageTitle
                  title={formatCurrency(
                    Number(formData?.amountReceived || 0) -
                      empRecieveSelectDeductions.reduce(
                        (total, item) => total + Number(item?.payment || 0),
                        0,
                      ),
                  )}
                  tag="span"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-8">
          <Button
            title={"Close "}
            variant="outlined"
            onClick={handleResetNClose}
          />
          <Button
            title="Save"
            onClick={() => handleSave()}
            disabled={
              Number(formData?.amountReceived || 0) -
                empRecieveSelectDeductions.reduce(
                  (total, item) => total + Number(item?.payment || 0),
                  0,
                ) <
              0
            }
          />
        </div>
      </div>
      <div>
        {/* <Unapaidtimesheet
          isOpen={showUnpaidtimesheet}
          onClose={() => setShowUnpaidtimesheet(false)}
        /> */}
      </div>
    </Modal>
  );
};

export default ReceivePayments;
